import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import Divider from "@mui/material/Divider";
import Drawer, { drawerClasses } from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import MenuContent from "./menu-content.component";
import { COLORS } from "../theme/theme.config";
import CloseIcon from '@mui/icons-material/Close';
import { BILLING_ENABLED } from "../config/features";
import { useMainApi } from "../provider/main-api.provider";

interface SideMenuMobileProps {
  open: boolean | undefined;
  toggleDrawer: (newOpen: boolean) => () => void;
}

export default function SideMenuMobile({
  open,
  toggleDrawer,
}: SideMenuMobileProps) {
  const { me } = useMainApi();
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: "none",
          backgroundColor: `${COLORS.primary}`,
        },
      }}
    >
      <Stack
        sx={{
          width: "70dvw",
          height: "100%",
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack
            direction="row"
            sx={{
              gap: 1,
              alignItems: "center",
              flexGrow: 1,
              p: 1,
              color: "#fff",
            }}
          >
            <CloseIcon onClick={toggleDrawer(false)} />
          </Stack>
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent />
          <Divider />
        </Stack>
        <Stack
          direction="row"
          sx={{
            p: 2,
            gap: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            startIcon={<LightbulbOutlinedIcon />}
            variant="outlined"
            size="small"
            className="side-menu-mobile-ideas-btn"
            sx={{
              color: "#c7d8ff",
              borderColor: "rgba(35, 100, 232, 0.45)",
              backgroundColor: "rgba(35, 100, 232, 0.12)",
              textTransform: "none",
              fontSize: "13px",
              fontWeight: 600,
              flex: 1,
              borderRadius: "10px",
              "&:hover": {
                borderColor: "rgba(35, 100, 232, 0.7)",
                backgroundColor: "rgba(35, 100, 232, 0.2)",
                color: "#fff",
              },
            }}
            onClick={() =>
              window.open(
                "https://theunplan.featurebase.app/",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            Ideas
          </Button>
          {BILLING_ENABLED && !me?.has_subscription && (
            <Button
              variant="contained"
              size="small"
              component="a"
              href="/plans"
              sx={{
                textTransform: "none",
                background: "linear-gradient(120deg, #2364e8, #1746b3)",
                color: "#fff",
                boxShadow: "0 8px 18px rgba(35, 100, 232, 0.28)",
                fontSize: "13px",
                padding: "7px 12px",
                fontWeight: 700,
                borderRadius: "10px",
                flex: 1,
                "&:hover": {
                  background: "linear-gradient(120deg, #1a56c9, #123a96)",
                  boxShadow: "0 10px 22px rgba(35, 100, 232, 0.34)",
                },
              }}
            >
              Upgrade
            </Button>
          )}
        </Stack>
      </Stack>
    </Drawer>
  );
}
